/**
 * AlmadarPostWhyStateMachinesForBusinessSLAlmadarPostWhyStateMachinesForBusinessSLPage
 *
 * Page component for AlmadarPostWhyStateMachinesForBusinessSLAlmadarPostWhyStateMachinesForBusinessSLPage
 * Path: /sl/blog/why-state-machines-for-business
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWhyStateMachinesForBusinessSLPostPageView as __AlmadarPostWhyStateMachinesForBusinessSLPostPageView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessSLPostPageView';
import { AlmadarPostWhyStateMachinesForBusinessSLPostAnalyticsView as __AlmadarPostWhyStateMachinesForBusinessSLPostAnalyticsView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessSLPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWhyStateMachinesForBusinessSLAlmadarPostWhyStateMachinesForBusinessSLPageProps {
  // Add any page-level props here
}

export function AlmadarPostWhyStateMachinesForBusinessSLAlmadarPostWhyStateMachinesForBusinessSLPage(_props: AlmadarPostWhyStateMachinesForBusinessSLAlmadarPostWhyStateMachinesForBusinessSLPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWhyStateMachinesForBusinessSLPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWhyStateMachinesForBusinessSLPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWhyStateMachinesForBusinessSLAlmadarPostWhyStateMachinesForBusinessSLPage;
